import { cn } from '../../lib/utils'

export default function Card({
  children,
  className,
  hover = true,
  ...props
}) {
  const baseStyles = 'bg-dark-800 rounded-2xl p-8 border border-neutral-700/50 backdrop-blur-sm'
  const hoverStyles = hover ? 'transition-all duration-300 hover:-translate-y-1 hover:border-neon-lime/50 hover:shadow-lg hover:shadow-neon-lime/10' : ''

  return (
    <div
      className={cn(baseStyles, hoverStyles, className)}
      {...props}
    >
      {children}
    </div>
  )
}
